import http from './../../base/api/public'

let apiUrl = require('@/../config/sysConfig')

// 初期化
export const home = () => {
  return http.requestQuickGet(apiUrl.apiUrl_Initialization)
}

// メニュー状態管理検索
export const menuStateManager = (userCd) => {
  return http.requestGet(apiUrl.apiurl_MenuStateManager + "?userId=" + userCd)
}

//お知らせ検索
export const noticeDetailGet = (userCd) => {
  return http.requestGet(apiUrl.apiUrl_NoticeDetailSearch + '?userCd=' + userCd)
}

//パスワードフラグ検索
export const pwFlagGet = (userCd) => {
  return http.requestGet(apiUrl.apiUrl_PwFlag + '?userId=' + userCd)
}




// WEBPACK FOOTER //
// ./src/components/api/home.js